document.addEventListener('DOMContentLoaded', function() {
  var container = document.querySelector('.apexwolf-details');
  if (!container) return;

  var tabs = container.querySelectorAll('.apexwolf-details__tab');
  var contents = container.querySelectorAll('.apexwolf-details__content');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var targetId = this.getAttribute('data-tab');

      tabs.forEach(function(t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      this.classList.add('is-active');
      this.setAttribute('aria-selected', 'true');

      contents.forEach(function(content) {
        content.classList.remove('is-active');
      });

      var targetContent = container.querySelector('#tab-' + targetId);
      if (targetContent) {
        targetContent.classList.add('is-active');
      }
    });
  });

  tabs.forEach(function(tab, index) {
    tab.addEventListener('keydown', function(e) {
      var newIndex;
      if (e.key === 'ArrowRight') {
        newIndex = (index + 1) % tabs.length;
        e.preventDefault();
      } else if (e.key === 'ArrowLeft') {
        newIndex = (index - 1 + tabs.length) % tabs.length;
        e.preventDefault();
      } else {
        return;
      }
      tabs[newIndex].focus();
      tabs[newIndex].click();
    });
  });
});
